import { render, staticRenderFns } from "./IdentityTablesList.vue?vue&type=template&id=2caf961a&"
import script from "./IdentityTablesList.vue?vue&type=script&lang=js&"
export * from "./IdentityTablesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports